<mat-card>{{'usersBalance' | translate}}


</mat-card>


<div class="container" style="padding: 25px;">

  <mat-grid-list cols="4" rowHeight="50px">
    <mat-grid-tile cols="2">
      <mat-form-field appearance="standard">
        <mat-label>{{'filter' | translate}}</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
      </mat-form-field>
    </mat-grid-tile>
    <mat-grid-tile></mat-grid-tile>
    <mat-grid-tile></mat-grid-tile>
    <!-- <mat-grid-tile>
      <span>
        {{'balance' | translate}} : {{ballance}}
      </span>
    </mat-grid-tile> -->


  </mat-grid-list>

  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 30%;"> {{'name' | translate}} </th>
        <td mat-cell *matCellDef="let row" style="width: 30%;"> {{row.fullName}} </td>
      </ng-container>

      <ng-container matColumnDef="mobile">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 15%;"> {{'userName' | translate}} </th>
        <td mat-cell *matCellDef="let row" style="width: 30%;"> {{row.userName}} </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 15%;"> {{'email' | translate}} </th>
        <td mat-cell *matCellDef="let row" style="width: 20%;"> {{row.email}} </td>
      </ng-container>

      <ng-container matColumnDef="balance">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%;"> {{'balance' | translate}} </th>
        <td mat-cell *matCellDef="let row" style="width: 20%;"> {{row.balance}} </td>
      </ng-container>

      <ng-container matColumnDef="newbalance">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%;"> {{'addBallance' | translate}} </th>
        <td mat-cell *matCellDef="let row" style="width: 10%;">

          <mat-form-field appearance="standard">
            <input matInput name="balance" [(ngModel)]="row.newBallance">
          </mat-form-field>
        </td>
      </ng-container>


      <!-- <ng-container matColumnDef="dept">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%;"> {{'debit' | translate}} </th>
        <td mat-cell *matCellDef="let row" style="width: 10%;">
            
            <mat-form-field  appearance="standard">
                <input matInput name="debt" [(ngModel)]="row.dept">
              </mat-form-field>
        </td>
      </ng-container> -->

      <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'update' | translate}} </th>
        <td mat-cell *matCellDef="let row;let i = index;" style="width: 10%;padding: 10px;">
          <button mat-raised-button color="primary" (click)="update(row)">
            <mat-icon>save</mat-icon>
            {{'update' | translate}}
          </button>
          <!-- <button mat-raised-button color="accent" *ngIf="expression" (click)="edit(row.id)">
                <mat-icon>done</mat-icon>
                Save</button>
                &nbsp;
            <button mat-raised-button (click)="back()">
                <mat-icon>keyboard_backspace</mat-icon>
                Cancel</button> -->
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}} "{{input.value}}"</td>
      </tr>
    </table>

    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
  </div>

</div>

<app-matspinner dir="rtl" [overlay]="spinnerOverlay"></app-matspinner>

<ng-template #Modal>

  <h1 mat-dialog-title>Confirm</h1>
  <div mat-dialog-content>
    <p>are you sure to delete ?</p>

  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">No Thanks</button>
    <button mat-button cdkFocusInitial>Ok</button>
  </div>

</ng-template>